import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Hide = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="hide icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0607 4.04265C21.6464 3.45687 21.6464 2.50712 21.0607 1.92133C20.4749 1.33555 19.5251 1.33555 18.9393 1.92133L16.5589 4.30181C15.1403 3.77053 13.6041 3.48001 12 3.48001C6.7943 3.48001 2.30325 6.53981 0.227212 10.959C-0.0765512 11.6056 -0.0765512 12.3544 0.227212 13.001C1.01175 14.671 2.14119 16.1469 3.52375 17.3369L1.93934 18.9213C1.35355 19.5071 1.35355 20.4569 1.93934 21.0427C2.52513 21.6284 3.47487 21.6284 4.06066 21.0427L21.0607 4.04265ZM6.49301 14.3677L8.51832 12.3423C8.50621 12.2239 8.5 12.1037 8.5 11.982C8.5 10.049 10.067 8.48199 12 8.48199C12.1217 8.48199 12.2419 8.4882 12.3604 8.50032L14.3857 6.47501C13.6545 6.15782 12.8478 5.98199 12 5.98199C8.68629 5.98199 6 8.66829 6 11.982C6 12.8298 6.17583 13.6365 6.49301 14.3677Z"
    />
    <path
      className={pathClass}
      d="M17.7705 10.3328L21.0021 7.10119C22.1465 8.19987 23.0902 9.50596 23.7728 10.959C24.0766 11.6057 24.0766 12.3544 23.7728 13.001C21.6968 17.4202 17.2057 20.48 12 20.48C10.6745 20.48 9.39523 20.2816 8.19042 19.9129L10.3508 17.7525C10.8748 17.902 11.4281 17.982 12 17.982C15.3137 17.982 18 15.2957 18 11.982C18 11.41 17.92 10.8568 17.7705 10.3328Z"
    />
    <path
      className={pathClass}
      d="M15.4322 12.6711C15.1566 14.0513 14.0693 15.1386 12.6891 15.4142L15.4322 12.6711Z"
    />
  </svg>
)
